import request from '@/services/request'

export function OSSConfig() {
  return request({
    url: '//common-api.growlib.com/api/auth/sts',
    method: 'post'
  })
}

// 校验文件MD5值
export function md5Check(parameter) {
  return request({
    url: '//common-api.growlib.com/api/util/md5Check',
    method: 'post',
    isCommon: true,
    data: parameter
  })
}

export function utilReport(parameter) {
  return request({
    url: '//common-api.growlib.com/api/util/report',
    method: 'post',
    isCommon: true,
    data: parameter
  })
}
